module.exports = __webpack_public_path__ + "static/bloom-c0eda26f8b4432fc2c6a7e9e1660e719.png";